import React, { useEffect } from 'react';
import {
  CircularProgress,
  FormControl,
  FormHelperText,
  MenuItem,
  OutlinedInput,
  Select,
  TextField,
  Typography,
} from '@material-ui/core';
import { get } from 'lodash';
import { any, bool, func, string } from 'prop-types';
import classes from './styles.scss';

export default function BaseSelector({
  onlyShowText,
  label,
  errorMessage,
  valueKey,
  labelKey,
  loading,
  isDisabled,
  value,
  onSelectFieldChange,
  options,
  placeholder,
}) {
  const selectedValue = get(value, [valueKey], '');
  const selectedLabel = get(value, [labelKey], '');

  const drawPlaceholder = () => {
    if (selectedValue) {
      return selectedLabel;
    }
    return (
      <div className={classes.placeholderStyle}>
        {loading && <CircularProgress size={14} />}
        {placeholder}
      </div>
    );
  };

  return (
    <FormControl className={classes.selectFields}>
      <Typography className={classes.inputLabel}>{label}</Typography>
      {onlyShowText ? (
        <TextField
          variant="outlined"
          value={selectedLabel || ''}
          className={classes.selectFields}
          InputProps={{
            readOnly: true,
            classes: {
              input: classes.inputSelect,
              notchedOutline: classes.customBorderInput,
            },
          }}
          data-test="baseSelectorText"
        />
      ) : (
        <Select
          variant="outlined"
          onChange={onSelectFieldChange}
          value={selectedValue || ''}
          displayEmpty
          placeholder={placeholder}
          renderValue={drawPlaceholder}
          disabled={isDisabled}
          error={!!errorMessage}
          input={
            <OutlinedInput
              classes={{
                input: classes.inputSelect,
                notchedOutline: classes.customBorderInput,
              }}
              data-test="baseSelectorInput"
            />
          }
          data-test="baseSelectorBtn"
        >
          {loading && <MenuItem key={`loading-${label}`}>Loading...</MenuItem>}
          {!loading &&
            options.length &&
            options.map((item) => (
              <MenuItem
                value={item[valueKey] || ''}
                key={item[valueKey]}
                data-cy={item[labelKey]}
                data-test="baseSelectorMenuItem"
              >
                {item[labelKey]}
              </MenuItem>
            ))}
          {!loading && !options.length && (
            <MenuItem key={`loading-${label}`} data-test="baseSelectorNoOption">No Options</MenuItem>
          )}
        </Select>
      )}
      {errorMessage && (
        <FormHelperText error={!!errorMessage} className={classes.errorMessage}>
          {errorMessage}
        </FormHelperText>
      )}
    </FormControl>
  );
}

BaseSelector.propTypes = {
  onlyShowText: bool,
  label: string,
  value: any,
  options: any.isRequired,
  valueKey: string,
  labelKey: string,
  errorMessage: string,
  loading: bool,
  isDisabled: bool,
  onSelectFieldChange: func,
  placeholder: string,
};

BaseSelector.defaultProps = {
  valueKey: 'key',
  labelKey: 'label',
  placeholder: 'Select',
};
